import React, { FC, ReactNode } from "react";
import { CatalogSelectArrowIcon } from "assets/svgs/catalog";
import useTheme from "evcharging/hooks/useTheme";
import { css } from "@emotion/css";
import { Theme } from "evcharging/app/themes";

interface RatesDropdownProps {
  open: boolean;
  onToggle: () => void;
  placeholder: ReactNode;
  width: number;
}

const RatesDropdown: FC<RatesDropdownProps> = (props) => {
  const { placeholder, open, onToggle, children, width } = props;

  const theme = useTheme();
  const classes = createStyles(theme);

  return (
    <div className={classes.root} style={{ width }}>
      <button className={classes.button} onClick={onToggle}>
        <div>{placeholder}</div>
        <CatalogSelectArrowIcon style={{ transform: open ? "rotate(180deg)" : "none" }} />
      </button>
      <div
        className={classes.contentBox}
        style={{ display: open ? "block" : "none" }}
      >
        {children}
      </div>
    </div>
  );
};

const createStyles = (theme: Theme) => ({
  root: css({
    position: "relative",
    display: "block"
  }),
  button: css({
    color: '#1a1a1a',
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    border: "1px solid #D4D5DB",
    borderRadius: 6,
    backgroundColor: "#F8F8F8",
    height: 38,
    fontSize: 14,
    padding: "0 12px",
    "&:hover": {
      backgroundColor: "#F8F8F8"
    },
    "& svg": {
      transition: "all ease .2s"
    }
  }),
  contentBox: css({
    display: "none",
    position: "absolute",
    top: 45,
    backgroundColor: "#fff",
    border: "1px solid #D4D5DB",
    borderRadius: 6,
    zIndex: 1000,
    width: "100%"
  })
});

export default RatesDropdown;
